import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Vad kostar fasadmålning?",
    answer: "Priset varierar beroende på husets storlek, fasadtyp och skick. En normal villa kostar vanligtvis mellan 40 000 - 80 000 kr. Vi ger alltid en kostnadsfri offert efter besiktning så du vet exakt vad det kostar.",
  },
  {
    question: "Hur lång tid tar det att måla om fasaden?",
    answer: "En normalvilla tar vanligtvis 1-2 veckor, beroende på väder och fasadens skick. Vi planerar alltid in en marginal för eventuella väderstopp för att säkerställa bästa resultat.",
  },
  {
    question: "När är bästa tiden att måla fasaden?",
    answer: "Den bästa tiden är mellan maj och september när det är varmt och torrt. Färgen behöver rätt temperatur och luftfuktighet för att fästa ordentligt. Vi rekommenderar att boka tidigt på våren.",
  },
  {
    question: "Ingår ställning i priset?",
    answer: "Ja, ställning och all utrustning ingår alltid i våra offerter. Vi tar hand om allt praktiskt så du slipper tänka på det.",
  },
  {
    question: "Kan jag använda ROT-avdrag för fasadmålning?",
    answer: "Ja! Fasadmålning berättigar till ROT-avdrag på arbetskostnaden. Du kan få upp till 50% avdrag på arbetet (max 50 000 kr per person och år). Vi hjälper dig med all administration.",
  },
  {
    question: "Målar ni alla typer av hus?",
    answer: "Vi är specialiserade på trähus och träfasader. Det är där vi har vår expertis och kan garantera bästa möjliga resultat.",
  },
];

export default function FAQSection() {
  return (
    <section className="section-padding bg-slate-50" data-testid="faq-section">
      <div className="container mx-auto max-w-3xl">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <span className="text-sm font-semibold tracking-wider uppercase text-[#b91c1c]">
            Vanliga frågor
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight">
            Frågor & svar om fasadmålning
          </h2>
          <p className="text-lg text-slate-600">
            Här hittar du svar på de vanligaste frågorna vi får.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white rounded-xl border border-slate-200 px-6 data-[state=open]:shadow-md transition-shadow"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-slate-900 hover:text-[#b91c1c] py-5 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
